var _extend = require('lodash/extend');

function PoweredByWidget(options) {
  options = options || {};
  
  var defaultOptions = {
    marker: '',
    locale: 'en',
    erid: '',
    id: '',
    node: null,
    utm_medium: 'network',
    utm_keyword: '',
    promo_id: '',
    utm_campaign: '',
    show: false,
    wrapper_styles: 'position: absolute; bottom: -27px; right: 0;',
    check_parent_color: true,
    origin_promo_id: '',
    send_metrics: true
  };
  
  this.options = _extend({}, defaultOptions, options);

  if (this.options.show) {
    this.init();
  }
}

PoweredByWidget.prototype.init = function() {
  window.TP_POWERED_BY = window.TP_POWERED_BY || { 
    opts: [], 
    cb: false, 
    loading: false 
  };

  if (window.TP_POWERED_BY.cb) {
    window.TP_POWERED_BY.cb(this.options);
  } else {
    window.TP_POWERED_BY.opts.push(this.options);
    if (!window.TP_POWERED_BY.loading) {
      window.TP_POWERED_BY.loading = true;
      this.loadScript();
    }
  }
};

PoweredByWidget.prototype.loadScript = function() {
  var script = document.createElement('script');
  var currentOrigin = this.getCurrentOrigin();
  script.src = currentOrigin + '/powered_by/powered_by.js';
  script.onerror = function() {
    console.warn('Failed to load powered_by script');
    window.TP_POWERED_BY.loading = false;
  };
  document.head.appendChild(script);
};

PoweredByWidget.prototype.getCurrentOrigin = function() {
  return 'https://tpwgt.com';
};

module.exports = PoweredByWidget;